@defer{
<!--    @if(mainStore.whiteLabel.header.layout.value === LayoutTypes.HORIZONTAL){-->

<!--    } @else if(mainStore.whiteLabel.header.layout.value === LayoutTypes.VERTICAL){-->

<!--    } @else if (mainStore.whiteLabel.header.layout.value === LayoutTypes.COMPACT){-->

<!--    }-->

    <div class="hidden flex-col lg:flex min-h-screen bg-bg-primary"  >
        <white-label-default-header></white-label-default-header>
        <app-configuration-side-bar></app-configuration-side-bar>
        <!-- 3 column wrapper -->
        <div class="mx-auto w-full  grow md:flex">
            <!-- Left sidebar & main wrapper -->
            <div class="flex-1 w-full lg:flex">
                <div class="w-full lg:flex-1">
                    <router-outlet></router-outlet>
                </div>
                <div class="w-96" [ngClass]="{
                'hidden': !pageBuilderStore.sideBarIsOpen
            }"></div>
            </div>
        </div>
    </div>




    <div class="lg:hidden fixed top-0 left-0 h-full w-full bg-card z-20 flex items-center justify-around">
        <div class="text-gray-400 text-center">
            <svg width="100" height="100" class="m-auto" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="4" width="18" height="12" rx="2" ry="2" fill="currentColor"/>
                <rect x="8" y="18" width="8" height="2" fill="currentColor"/>
                <path d="M5 20H19V22H5V20Z" fill="currentColor"/>
            </svg>
            <h2 class="text-2xl">Page builder working only for desktop view</h2>
            <a class="text-normal underline cursor-pointer" [routerLink]="['../']">Go Back</a>
        </div>
    </div>

    <white-label-default-footer></white-label-default-footer>
} @placeholder {
    <div></div>
}